import { createContext, useContext, useEffect, useState } from "react";
import { useClientPayments } from "./ClientPayments";

const ClientPaymentContext = createContext(null);

export const ClientPaymentContextProvider = ({ children, clientPaymentId }) => {
  const {
    clientPayments,
    getClientPaymentById,
    updateClientPayment: updateClientPaymentContext,
    deleteClientPayment: deleteClientPaymentContext,
    getClientPayments,
    loading,
  } = useClientPayments();
  const [clientPayment, setClientPayment] = useState(null);

  const getClientPayment = () => {
    const newClient = getClientPaymentById(clientPaymentId);
    setClientPayment(newClient);
  };

  const updateClientPayment = async (body) => {
    return await updateClientPaymentContext(clientPaymentId, body);
  };

  const deleteClientPayment = async () => {
    const res = await deleteClientPaymentContext();
    return res;
  };

  useEffect(() => {
    if (clientPayments.length === 0) {
      getClientPayments();
    } else {
      getClientPayment();
    }
  }, [clientPaymentId, clientPayments]);

  return (
    <ClientPaymentContext.Provider
      value={{
        clientPayment,
        updateClientPayment,
        deleteClientPayment,
        loading,
      }}
    >
      {children}
    </ClientPaymentContext.Provider>
  );
};

export const useClientPayment = () => useContext(ClientPaymentContext);
